(function() {

	$( window.theme.loader ).toggleClass( 'active' );

		var searchParams = new URLSearchParams( window.location.search );
		var template = $( '.order' );

		$( '#single-order-return-link' ).attr( 'href', $( '#single-order-return-link' ).attr( 'href' ) + '?last_name=' + searchParams.get( 'last_name' ) + '&email=' + searchParams.get( 'email' ) );

		var shareModalFocus = function( e ) {

			var isTabPressed = e.key === 'Tab' || e.keyCode === 9;

			var closeButton = document.getElementById( 'share-memories-modal-closer' );
			var submitButton = document.getElementById( 'share-memories-modal-submit-button' );

			if (!isTabPressed) {

				return;

			}

			if ( e.shiftKey ) {

				if ( document.activeElement === closeButton ) {

					setTimeout(function(){

						submitButton.focus();

					}, 300 );

					e.preventDefault();
				}

			} else {

				if ( document.activeElement === submitButton ) {

					setTimeout(function(){

						closeButton.focus();

					}, 300 );

					e.preventDefault();

				}

			}

		}

		$( document ).on( 'click', '[ data-toggle-active ]', function( event ){

			event.preventDefault();

			var target = $( this ).data( 'toggle-active' )

			$( target ).toggleClass( 'active' );

			if( $( target ).hasClass( 'share-memories-modal' ) ) {

				setTimeout( function() {

					$( '#share-memories-modal-closer' ).focus();

				}, 100);

				document.addEventListener( 'keydown', function( e ) {

					shareModalFocus( e );

				} );

				//adds onclick to the off-canvas to remove the keydown event listener when the offcanvas is closed
				$( '#share-memories-modal-closer' ).on( 'click', function() {

					document.removeEventListener( 'keydown', function( e ) {

						shareModalFocus( e );

					} );

					setTimeout( function() {

						$( this )[ 0 ].focus();

					}, 100 );

				});

			}

			return false;

		});

		if( searchParams.has( 'reference_number' ) ){

			if( window.theme.yes_video_api_url && window.theme.yes_video_bearer_token && window.theme.yes_video_api_x_domain ){

				// get order
				$.ajax({
					url : window.theme.yes_video_api_url + '/api/v1/orders/' + searchParams.get( 'reference_number' ),
					headers : {
						'Accept' : 'application/json',
						'Content-type' : 'application/json',
						'X-Shopify-Shop-Domain' : window.theme.yes_video_api_x_domain,
						'Authorization' : 'Bearer ' + window.theme.yes_video_bearer_token
					},
					type : 'GET',
					dataType : 'json',
					success : function( res ) {

						var order = res.order_detail;
						var details = $( '[data-details]', template );
						var timeline = $( '[data-timeline]', template );

						$( '[data-id]', template ).html( ' > <strong>#' + order.number + '</strong>' );

						if( order.external_status == 'Activated' ){

							var status = '<div>' +
								'<h1 class="text-green-default text-2xl font-bold mb-5 text-center">Created</h1>' +
								'<p class="mb-5 text-base text-black text-center">' + window.theme.order_statuses.order_status_activated_upper_text + '</p>' +
								'<p class="mb-5 text-base text-black text-center">' + window.theme.order_statuses.order_status_activated_lower_text + ' ' + '<a class="text-blue-default" target="_blank" href="' + order.inbound_shipment.tracking_url + '">www.ups.com</a>.</p>' +
							'</div>';

							if( order.activated ){

								var history = '<p><strong>' + new Date( order.placed_at ).toLocaleDateString( 'en-US', { year: "numeric", month: "2-digit", day: "2-digit" } ) + '</strong> <br> Activated Time Capsule</p>'

							} else {

								var history = '<p><strong>' + new Date( order.placed_at ).toLocaleDateString( 'en-US', { year: "numeric", month: "2-digit", day: "2-digit" } ) + '</strong> <br> Created</p>'

							}

							if( order.auto_export_gp_email && order.auto_export_gp_email.length > 0 && window.theme.order_statuses.show_share_memories === 'true' ) {

								status += '<div>';
								status += '<a href="#" role="button" id="share-trigger" data-toggle-active=".share-memories-modal" class="order-activate-actions-card order-activation-share-link">';
								status += '<div class="order-activate-actions-card-information">';
								status += '<h2>' + window.theme.order_statuses.order_status_share_link_title + '</h2>';
								status += '<p>' + window.theme.order_statuses.order_status_share_link_excerpt + '</p>';
								status += '</div>';
								status += '<div class="order-activate-actions-card-link">';
								status += '<svg width="21px" height="14px" viewBox="0 0 21 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1129.000000, -5692.000000)" fill="#4784F2" fill-rule="nonzero"><g transform="translate(0.000000, 5467.000000)"><g transform="translate(270.000000, 207.000000)"><path d="M871.909,18.262 C871.551921,18.6183104 871.548797,19.1958473 871.902,19.556 L876.177,23.838 L859.907,23.838 C859.402212,23.838 858.993,24.2472117 858.993,24.752 C858.993,25.2567883 859.402212,25.666 859.907,25.666 L876.17,25.666 L871.895,29.952 C871.545034,30.3134586 871.548144,30.8883487 871.902,31.246 C872.073587,31.4157533 872.305586,31.510384 872.54695,31.5090847 C872.788314,31.5077585 873.019269,31.4106097 873.189,31.239 L878.983,25.403 L878.983,25.403 C879.062137,25.3184136 879.126378,25.2210371 879.173,25.115 C879.220488,25.0037895 879.244326,24.8839177 879.243052,24.763 C879.243052,24.5239102 879.14987,24.2942259 878.983,24.123 L873.189,18.287 C873.023296,18.1126572 872.794702,18.0118961 872.554221,18.0071992 C872.31374,18.0025023 872.081385,18.0942604 871.909,18.262 Z" ></path></g></g></g></g></svg>';
								status += '</div>';
								status += '</a>';
								status += '</div>';

							}

						} else if( order.external_status == 'Created' ){

							var status = '<div>' +
								'<h1 class="text-green-default text-2xl font-bold mb-5 text-center">Created</h1>' +
								'<p class="mb-5 text-base text-black text-center">' + window.theme?.order_statuses?.order_status_created_text + '</p>' +
							'</div>';

							if( order.placed_at ){

								var history = '<div><p>Created: <br><strong>' + new Date( order.placed_at ).toLocaleDateString( 'en-US', { year: "numeric", month: "2-digit", day: "2-digit" } ) + '</strong></p></div>'

							}

							if( order.auto_export_gp_email && order.auto_export_gp_email.length > 0 && window.theme.order_statuses.show_share_memories === 'true' ){

								status += '<div>';
								status += '<a href="#" role="button" id="share-trigger" data-toggle-active=".share-memories-modal" class="order-activate-actions-card order-activation-share-link">';
								status += '<div class="order-activate-actions-card-information">';
								status += '<h2>' + window.theme.order_statuses.order_status_share_link_title + '</h2>';
								status += '<p>' + window.theme.order_statuses.order_status_share_link_excerpt + '</p>';
								status += '</div>';
								status += '<div class="order-activate-actions-card-link">';
								status += '<svg width="21px" height="14px" viewBox="0 0 21 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1129.000000, -5692.000000)" fill="#4784F2" fill-rule="nonzero"><g transform="translate(0.000000, 5467.000000)"><g transform="translate(270.000000, 207.000000)"><path d="M871.909,18.262 C871.551921,18.6183104 871.548797,19.1958473 871.902,19.556 L876.177,23.838 L859.907,23.838 C859.402212,23.838 858.993,24.2472117 858.993,24.752 C858.993,25.2567883 859.402212,25.666 859.907,25.666 L876.17,25.666 L871.895,29.952 C871.545034,30.3134586 871.548144,30.8883487 871.902,31.246 C872.073587,31.4157533 872.305586,31.510384 872.54695,31.5090847 C872.788314,31.5077585 873.019269,31.4106097 873.189,31.239 L878.983,25.403 L878.983,25.403 C879.062137,25.3184136 879.126378,25.2210371 879.173,25.115 C879.220488,25.0037895 879.244326,24.8839177 879.243052,24.763 C879.243052,24.5239102 879.14987,24.2942259 878.983,24.123 L873.189,18.287 C873.023296,18.1126572 872.794702,18.0118961 872.554221,18.0071992 C872.31374,18.0025023 872.081385,18.0942604 871.909,18.262 Z" ></path></g></g></g></g></svg>';
								status += '</div>';
								status += '</a>';
								status += '</div>';

							}

						} else if( order.external_status == 'Waiting to Ship' ){

							var status = '<div>' +
								'<h1 class="text-green-default text-2xl font-bold mb-5 text-center">Waiting to Ship</h1>' +
								'<p class="mb-5 text-base text-black text-center">' + window.theme.order_statuses.order_status_waiting_text + '</p>' +
							'</div>';

							if( order.activated ){

								var history = '<p><strong>' + new Date( order.placed_at ).toLocaleDateString( 'en-US', { year: "numeric", month: "2-digit", day: "2-digit" } ) + '</strong> <br> Activated Time Capsule</p>'

							} else {

								var history = '<p><strong>' + new Date( order.placed_at ).toLocaleDateString( 'en-US', { year: "numeric", month: "2-digit", day: "2-digit" } ) + '</strong> <br> Created</p>'

							}

							if( order.arrived_at ){

								$( '.single-order-timeline-shape' ).addClass( 'active' );

								history += '<p><strong>' + new Date( order.arrived_at ).toLocaleDateString( 'en-US', { year: "numeric", month: "2-digit", day: "2-digit" } ) + '</strong> <br> Arrived at processing facility</p>'

							}

						} else if( order.external_status == 'Received' ){

							var status = '<div>' +
								'<h1 class="text-green-default text-2xl font-bold mb-5 text-center">Received</h1>' +
								'<p class="mb-5 text-base text-black text-center">' + window.theme.order_statuses.order_status_recieved_text + '</p>' +
							'</div>';

							if( order.activated ){

								var history = '<p><strong>' + new Date( order.placed_at ).toLocaleDateString( 'en-US', { year: "numeric", month: "2-digit", day: "2-digit" } ) + '</strong> <br> Activated Time Capsule</p>'

							} else {

								var history = '<p><strong>' + new Date( order.placed_at ).toLocaleDateString( 'en-US', { year: "numeric", month: "2-digit", day: "2-digit" } ) + '</strong> <br> Created</p>'

							}

							if( order.arrived_at ){

								$( '.single-order-timeline-shape' ).addClass( 'active' );

								history += '<p><strong>' + new Date( order.arrived_at ).toLocaleDateString( 'en-US', { year: "numeric", month: "2-digit", day: "2-digit" } ) + '</strong> <br> Arrived at processing facility</p>'

							}

							if( order.auto_export_gp_email && order.auto_export_gp_email.length > 0 && window.theme.order_statuses.show_share_memories === 'true' ){

								status += '<div>';
								status += '<a href="#" role="button" id="share-trigger" data-toggle-active=".share-memories-modal" class="order-activate-actions-card order-activation-share-link">';
								status += '<div class="order-activate-actions-card-information data-toggle-active=".share-memories-modal">';
								status += '<h2>' + window.theme.order_statuses.order_status_share_link_title + '</h2>';
								status += '<p class="mb-5 text-base text-black text-center">' + window.theme.order_statuses.order_status_share_link_excerpt + '</p>';
								status += '</div>';
								status += '<div class="order-activate-actions-card-link">';
								status += '<svg width="21px" height="14px" viewBox="0 0 21 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1129.000000, -5692.000000)" fill="#4784F2" fill-rule="nonzero"><g transform="translate(0.000000, 5467.000000)"><g transform="translate(270.000000, 207.000000)"><path d="M871.909,18.262 C871.551921,18.6183104 871.548797,19.1958473 871.902,19.556 L876.177,23.838 L859.907,23.838 C859.402212,23.838 858.993,24.2472117 858.993,24.752 C858.993,25.2567883 859.402212,25.666 859.907,25.666 L876.17,25.666 L871.895,29.952 C871.545034,30.3134586 871.548144,30.8883487 871.902,31.246 C872.073587,31.4157533 872.305586,31.510384 872.54695,31.5090847 C872.788314,31.5077585 873.019269,31.4106097 873.189,31.239 L878.983,25.403 L878.983,25.403 C879.062137,25.3184136 879.126378,25.2210371 879.173,25.115 C879.220488,25.0037895 879.244326,24.8839177 879.243052,24.763 C879.243052,24.5239102 879.14987,24.2942259 878.983,24.123 L873.189,18.287 C873.023296,18.1126572 872.794702,18.0118961 872.554221,18.0071992 C872.31374,18.0025023 872.081385,18.0942604 871.909,18.262 Z" ></path></g></g></g></g></svg>';
								status += '</div>';
								status += '</a>';
								status += '</div>';

							}

						} else if( order.external_status == 'Processing' ) {

							var status = '<div>' +
								'<h1 class="text-green-default text-2xl font-bold mb-5 text-center">Processing</h1>' +
								'<p class="mb-5 text-base text-black text-center">' + window.theme.order_statuses.order_status_processing_text + '</p>' +
							'</div>';

							if( order.activated ){

								var history = '<p><strong>' + new Date( order.placed_at ).toLocaleDateString( 'en-US', { year: "numeric", month: "2-digit", day: "2-digit" } ) + '</strong> <br> Activated Time Capsule</p>'

							} else {

								var history = '<p><strong>' + new Date( order.placed_at ).toLocaleDateString( 'en-US', { year: "numeric", month: "2-digit", day: "2-digit" } ) + '<br></strong> Created</p>'

							}

							if( order.arrived_at ){

								$( '.single-order-timeline-shape' ).addClass( 'active' );

								history += '<p><strong>' + new Date( order.arrived_at ).toLocaleDateString( 'en-US', { year: "numeric", month: "2-digit", day: "2-digit" } ) + '</strong> <br> Arrived at processing facility</p>'

							}

							if( order.auto_export_gp_email && order.auto_export_gp_email.length > 0 && window.theme.order_statuses.show_share_memories === 'true' ){

								status += '<div>';
								status += '<a href="#" role="button" id="share-trigger" data-toggle-active=".share-memories-modal" class="order-activate-actions-card order-activation-share-link">';
								status += '<div class="order-activate-actions-card-information">';
								status += '<h2>' + window.theme.order_statuses.order_status_share_link_title + '</h2>';
								status += '<p>' + window.theme.order_statuses.order_status_share_link_excerpt + '</p>';
								status += '</div>';
								status += '<div class="order-activate-actions-card-link">';
								status += '<svg width="21px" height="14px" viewBox="0 0 21 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1129.000000, -5692.000000)" fill="#4784F2" fill-rule="nonzero"><g transform="translate(0.000000, 5467.000000)"><g transform="translate(270.000000, 207.000000)"><path d="M871.909,18.262 C871.551921,18.6183104 871.548797,19.1958473 871.902,19.556 L876.177,23.838 L859.907,23.838 C859.402212,23.838 858.993,24.2472117 858.993,24.752 C858.993,25.2567883 859.402212,25.666 859.907,25.666 L876.17,25.666 L871.895,29.952 C871.545034,30.3134586 871.548144,30.8883487 871.902,31.246 C872.073587,31.4157533 872.305586,31.510384 872.54695,31.5090847 C872.788314,31.5077585 873.019269,31.4106097 873.189,31.239 L878.983,25.403 L878.983,25.403 C879.062137,25.3184136 879.126378,25.2210371 879.173,25.115 C879.220488,25.0037895 879.244326,24.8839177 879.243052,24.763 C879.243052,24.5239102 879.14987,24.2942259 878.983,24.123 L873.189,18.287 C873.023296,18.1126572 872.794702,18.0118961 872.554221,18.0071992 C872.31374,18.0025023 872.081385,18.0942604 871.909,18.262 Z" ></path></g></g></g></g></svg>';
								status += '</div>';
								status += '</a>';
								status += '</div>';

							}

						} else if( order.external_status == 'Upload Pending' ){

							var status = '<div>' +
								'<h1 class="text-green-default text-2xl font-bold mb-5 text-center">Upload Pending</h1>' +
								'<p class="mb-5 text-base text-black text-center">' + window.theme.order_statuses.order_status_upload_upper_text + '</p>' +
								'<p class="mb-5 text-base text-black text-center"><strong>' + order.auto_export_gp_email + '</strong></p>' +
								'<p class="mb-5 text-base text-black text-center">' + window.theme.order_statuses.order_status_upload_lower_text + '</p>' +
							'</div>';

							var history = '';

							if( order.activated ){

								history += '<p><strong>' + new Date( order.placed_at ).toLocaleDateString( 'en-US', { year: "numeric", month: "2-digit", day: "2-digit" } ) + '</strong> <br> Activated Time Capsule</p>'

							}

							if( order.arrived_at ){

								$( '.single-order-timeline-shape' ).addClass( 'active' );

								history += '<p><strong>' + new Date( order.arrived_at ).toLocaleDateString( 'en-US', { year: "numeric", month: "2-digit", day: "2-digit" } ) + '</strong> <br>Arrived at processing facility</p>'

							}

							if( order.outbound_shipments[0].shipped_at ){

								$( '.single-order-timeline-shape' ).addClass( 'active' );

								history += '<p><strong>' + new Date( order.outbound_shipments[0].shipped_at ).toLocaleDateString( 'en-US', { year: "numeric", month: "2-digit", day: "2-digit" } ) + '</strong> <br> Shipped</p>'

							}

							if( order.auto_export_gp_email && order.auto_export_gp_email.length > 0 && window.theme.order_statuses.show_share_memories === 'true' ){

								status += '<a href="#" role="button" id="share-trigger" data-toggle-active=".share-memories-modal" class="order-activate-actions-card order-activation-share-link">';
								status += '<div class="order-activate-actions-card-information">';
								status += '<h2>' + window.theme.order_statuses.order_status_share_link_title + '</h2>';
								status += '<p>' + window.theme.order_statuses.order_status_share_link_excerpt + '</p>';
								status += '</div>';
								status += '<div class="order-activate-actions-card-link">';
								status += '<svg width="21px" height="14px" viewBox="0 0 21 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1129.000000, -5692.000000)" fill="#4784F2" fill-rule="nonzero"><g transform="translate(0.000000, 5467.000000)"><g transform="translate(270.000000, 207.000000)"><path d="M871.909,18.262 C871.551921,18.6183104 871.548797,19.1958473 871.902,19.556 L876.177,23.838 L859.907,23.838 C859.402212,23.838 858.993,24.2472117 858.993,24.752 C858.993,25.2567883 859.402212,25.666 859.907,25.666 L876.17,25.666 L871.895,29.952 C871.545034,30.3134586 871.548144,30.8883487 871.902,31.246 C872.073587,31.4157533 872.305586,31.510384 872.54695,31.5090847 C872.788314,31.5077585 873.019269,31.4106097 873.189,31.239 L878.983,25.403 L878.983,25.403 C879.062137,25.3184136 879.126378,25.2210371 879.173,25.115 C879.220488,25.0037895 879.244326,24.8839177 879.243052,24.763 C879.243052,24.5239102 879.14987,24.2942259 878.983,24.123 L873.189,18.287 C873.023296,18.1126572 872.794702,18.0118961 872.554221,18.0071992 C872.31374,18.0025023 872.081385,18.0942604 871.909,18.262 Z" ></path></g></g></g></g></svg>';
								status += '</div>';
								status += '</a>';

							}

						} else if( order.external_status == 'Canceled' ){

							var status = '<div>' +
								'<h1 class="text-green-default text-2xl font-bold mb-5 text-center">Canceled</h1>' +
								'<p class="mb-5 text-base text-black text-center">' + window.theme.order_statuses.order_status_canceled_upper_text + '</p>' +
								'<p class="mb-5 text-base text-black text-center">' + window.theme.order_statuses.order_status_canceled_lower_text + '</p>' +
							'</div>';

							if( order.activated ){

								var history = '<p><strong>' + new Date( order.placed_at ).toLocaleDateString( 'en-US', { year: "numeric", month: "2-digit", day: "2-digit" } ) + '</strong> <br> Activated Time Capsule</p>'

							} else {

								var history = '<p><strong>' + new Date( order.placed_at ).toLocaleDateString( 'en-US', { year: "numeric", month: "2-digit", day: "2-digit" } ) + '</strong> <br> Created</p>'

							}

							if( order.arrived_at ){

								$( '.single-order-timeline-shape' ).addClass( 'active' );

								history += '<p><strong>' + new Date( order.arrived_at ).toLocaleDateString( 'en-US', { year: "numeric", month: "2-digit", day: "2-digit" } ) + '</strong> <br> Arrived at processing facility</p>'

							}

						} else if( order.external_status == 'Payment Required' ){

							var status = '<div>' +
								'<h1 class="text-green-default text-2xl font-bold mb-5 text-center">Payment Required</h1>' +
								'<p class="mb-5 text-base text-black text-center">' + window.theme.order_statuses.order_status_payment_text + '</p>' +
								'<a style="margin:0 auto;" class="button button-primary" id="single-order-payment" href="' + window.theme.yes_video_balance_page_url + order.guest_token + '"> Make a Payment</a>'
							'</div>';

							if( order.activated ){

								var history = '<p><strong>' + new Date( order.placed_at ).toLocaleDateString( 'en-US', { year: "numeric", month: "2-digit", day: "2-digit" } ) + '</strong> <br> Activated Time Capsule</p>'

							} else {

								var history = '<p><strong>' + new Date( order.placed_at ).toLocaleDateString( 'en-US', { year: "numeric", month: "2-digit", day: "2-digit" } ) + '</strong> <br> Created</p>'

							}

							if( order.arrived_at ){

								$( '.single-order-timeline-shape' ).addClass( 'active' );

								history += '<p><strong>' + new Date( order.arrived_at ).toLocaleDateString( 'en-US', { year: "numeric", month: "2-digit", day: "2-digit" } ) + '</strong> <br> Arrived at processing facility</p>'

							}

						} else if( order.external_status == 'Shipped' ){

							var status = '<div>' +
								'<h1 class="text-green-default text-2xl font-bold mb-5 text-center">Shipped</h1>' +
								'<p class="mb-5 text-base text-black text-center">' + window.theme.order_statuses.order_status_shipped_text + ' <a class="text-blue-default" target="_blank" href="' + order.outbound_shipments[ 0 ].tracking_url + '">www.ups.com</a>.</p>' +
							'</div>';

							var history = '';

							if( order.activated ){

								history += '<p><strong>' + new Date( order.placed_at ).toLocaleDateString( 'en-US', { year: "numeric", month: "2-digit", day: "2-digit" } ) + '</strong> <br> Activated Time Capsule<p>'

							} else {

								history += '<p><strong>' + new Date( order.placed_at ).toLocaleDateString( 'en-US', { year: "numeric", month: "2-digit", day: "2-digit" } ) + '</strong> <br> Created</p>'

							}

							if( order.arrived_at ){

								$( '.single-order-timeline-shape' ).addClass( 'active' );

								history += '<p><strong>' + new Date( order.arrived_at ).toLocaleDateString( 'en-US', { year: "numeric", month: "2-digit", day: "2-digit" } ) + '</strong> <br> Arrived at processing facility</p>'

							}

							if( order.outbound_shipments[0].shipped_at ){

								$( '.single-order-timeline-shape' ).addClass( 'active' );

								history += '<p><strong>' + new Date( order.outbound_shipments[0].shipped_at ).toLocaleDateString( 'en-US', { year: "numeric", month: "2-digit", day: "2-digit" } ) + '</strong> <br> Shipped</p>'

							}

						} else if( order.external_status == 'Completed' ){

							var status = '<div>' +
								'<h1 class="text-green-default text-2xl font-bold mb-5 text-center">Completed</h1>'
							'</div>';

							var history = '';

							if( order.activated ){

								history += '<p><strong>' + new Date( order.placed_at ).toLocaleDateString( 'en-US', { year: "numeric", month: "2-digit", day: "2-digit" } ) + '</strong> <br> Activated Time Capsule<p>'

							} else {

								history += '<p><strong>' + new Date( order.placed_at ).toLocaleDateString( 'en-US', { year: "numeric", month: "2-digit", day: "2-digit" } ) + '</strong> <br> Created</p>'

							}

							if( order.arrived_at ){

								$( '.single-order-timeline-shape' ).addClass( 'active' );

								history += '<p><strong>' + new Date( order.arrived_at ).toLocaleDateString( 'en-US', { year: "numeric", month: "2-digit", day: "2-digit" } ) + '</strong> <br> Arrived at processing facility</p>'

							}

							if( order.outbound_shipments[0].shipped_at ){

								$( '.single-order-timeline-shape' ).addClass( 'active' );

								history += '<p><strong>' + new Date( order.outbound_shipments[0].shipped_at ).toLocaleDateString( 'en-US', { year: "numeric", month: "2-digit", day: "2-digit" } ) + '</strong> <br> Shipped</p>'

							}

						} else {

							var status = '<p>No order found.</p>';

						}

						details.append( status );
						timeline.append( history );

						$( window.theme.loader ).removeClass( 'active' );

					},
					error : function( err ){
						console.log( err );
						$( window.theme.loader ).removeClass( 'active' );

						window.theme.functions.triggerAlert( 'Incorrect order id', 'error' );

					}
				});

			}

		}

})();
